var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebPiece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8197 3.75C21.1819 3.75 21.4959 4.00063 21.5762 4.35383L22.0055 6.24166C22.2041 7.11484 22.8859 7.79666 23.7591 7.99521L25.6469 8.42449C26.0001 8.50479 26.2507 8.81882 26.2507 9.18103C26.2507 9.54325 26.0001 9.85728 25.6469 9.93758L23.7591 10.3669C22.8859 10.5654 22.2041 11.2472 22.0055 12.1204L21.5762 14.0083C21.4959 14.3614 21.1819 14.6121 20.8197 14.6121C20.4575 14.6121 20.1435 14.3614 20.0632 14.0083L19.6339 12.1204C19.4353 11.2472 18.7535 10.5654 17.8803 10.3669L15.9925 9.93758C15.6393 9.85728 15.3887 9.54325 15.3887 9.18103C15.3887 8.81882 15.6393 8.50479 15.9925 8.42449L17.8803 7.99521C18.7535 7.79666 19.4353 7.11484 19.6339 6.24166L20.0632 4.35383C20.1435 4.00063 20.4575 3.75 20.8197 3.75Z",
    fill: "#121111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2371 11.8984C15.0691 11.8984 14.1035 12.8434 14.1035 14.0321C14.1035 15.2208 15.0691 16.1657 16.2371 16.1657C17.4052 16.1657 18.3708 15.2208 18.3708 14.0321C18.3708 12.8434 17.4052 11.8984 16.2371 11.8984Z",
    fill: "#121111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85345 8.40625H14.3859C14.2815 8.64529 14.2241 8.90819 14.2241 9.18211C14.2241 9.45603 14.2815 9.71893 14.3859 9.95797H6.85345C5.99645 9.95797 5.30172 10.6527 5.30172 11.5097V18.1129C8.71649 17.2491 12.1612 18.1691 14.6571 20.3002C16.3061 19.2451 18.2501 18.983 20.0431 19.4256V15.6152C20.2821 15.7196 20.545 15.7769 20.819 15.7769C21.0929 15.7769 21.3558 15.7196 21.5948 15.6152V20.4825C21.5951 20.4942 21.5951 20.5059 21.5948 20.5177V23.9235C21.5948 25.6375 20.2054 27.0269 18.4914 27.0269H6.85345C5.13946 27.0269 3.75 25.6375 3.75 23.9235V11.5097C3.75 9.7957 5.13946 8.40625 6.85345 8.40625Z",
    fill: "#121111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebPiece);
export default __webpack_public_path__ + "static/media/icon_web_piece.ef99da01aabb37de3da8ed7aa207915c.svg";
export { ForwardRef as ReactComponent };